import actions from "./referraldoctor.action";

export default {
  namespaced: true,
  actions,
};
